<div *ngIf="!hideSearchFilter" class="filter-bar row">
  <app-search-bar [placeHolder]="'Search'" (onQueryChange)="onSearch($event)" [clearSearchInput]="clearSearch"></app-search-bar>
  <div class="spacer"></div>

  <app-multiselectable-dropdown *ngIf="!hideRegionFilter" class="col-md-2" [title]="'Regions'" [clearAll]="clearFilter" (onSelect)="onSelectRegion($event)" [items]="regionOptions" [selectedItem]="selectedRegionIds"></app-multiselectable-dropdown>
  <app-multiselectable-dropdown *ngIf="!hideAssetFilter" class="col-md-2" [title]="'Assets'" [clearAll]="clearFilter" (onSelect)="onSelectAsset($event)" [items]="assetOptions" [selectedItem]="selectedAssetIds"></app-multiselectable-dropdown>
  <app-multiselectable-dropdown class="col-md-2" [title]="'Deposits'" [clearAll]="clearFilter" (onSelect)="onSelectDeposit($event)" [items]="depositeOptions" [selectedItem]="selectedDepositIds"></app-multiselectable-dropdown>
  <app-button
    class="col-md-1"
    [name]="'clear All'"
    [disable]="(inputSearched == '') && (selectedRegions && !selectedRegions.length) && (selectedAssets && !selectedAssets.length) && (selectedDeposits && !selectedDeposits.length)"
    [type]="'outlined'"
    (btnClick)="clearAllFilters()"
></app-button>
</div>